import { useState, useEffect } from 'react';

import useService from '../../utils/useService';
import { BulkReplyFilters } from '../../utils/constants';

const useList = () => {
	const [filters, setFilters] = useState<BulkReplyFilters>();
	const [showLoader, setShowLoader] = useState(false);
	const [bulkReplyData, setBulkReplyData] = useState({ rowCount: 0, data: [] });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const { listBulkReply } = useService();

	const fetchBulkReplyData = async () => {
		try {
			setShowLoader(true);
			const transactionHistory = await listBulkReply(filters);
			setBulkReplyData({ rowCount: transactionHistory.rowCount, data: transactionHistory.data });
			setForceUpdate(true);
		} catch (error: any) {
			setBulkReplyData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (filters) {
			fetchBulkReplyData();
		}
	}, [filters]);

	const handleFilterSubmit = (submittedFilters: { fromToDate?: Date[] }) => {
		const { fromToDate } = submittedFilters;

		if (fromToDate && fromToDate.length === 2) {
			setFilters({ from: fromToDate[0].getTime(), to: fromToDate[1].getTime() + 86400000 });
		}
	};

	const getBulkReplyData = () => {
		setForceUpdate(false);
		return bulkReplyData;
	};

	return { getBulkReplyData, handleFilterSubmit, forceUpdate, showLoader, setShowLoader };
};

export default useList;
